import React from 'react';

/*
  SVG-based diagonal "Emulation mode" watermark, repeated as a CSS background.
  Equivalent visual to Vue's <n-watermark cross rotate=-15>. The element sits
  above content (z-index < modal) but is fully click-through.

  Light gray fill (`%23a0a0a0` = #a0a0a0) so the watermark reads as a subtle
  status overlay rather than a destructive warning. In dark mode the opacity
  is lowered so it stays legible against the #181818 page background.
*/
const WATERMARK_SVG =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='384' height='384'><g transform='rotate(-15 192 192)' font-family='Arial, sans-serif' font-size='16' font-weight='400' fill='%23a0a0a0'><text x='40' y='80'>Emulation mode</text><text x='40' y='192'>Emulation mode</text><text x='40' y='304'>Emulation mode</text></g></svg>\")";

const WATERMARK_STYLE: React.CSSProperties = {
  backgroundImage: WATERMARK_SVG,
};

// Tailwind owns z-index, opacity (with a dark: override), pointer-events,
// and the bg-repeat / bg-size utilities. The SVG data: URL must live in an
// inline style because Tailwind cannot safely produce arbitrary
// bg-url arbitrary-value classes with quoted SVG payloads — and any
// example written here would be picked up by the content scanner and
// emitted as a real CSS rule with an unresolvable url(), breaking webpack.
const WATERMARK_CLASS =
  'fixed inset-0 pointer-events-none z-[1500] opacity-55 bg-repeat' +
  ' [background-size:384px_384px]' +
  ' dark:opacity-[0.35]';

/**
 * Full-screen, click-through watermark shown while emulation is active.
 * Mirrors `<n-watermark content="Emulation mode" cross fullscreen ... />`
 * in RW-ERP-Service/UserEmulation.vue.
 */
const EmulationWatermark: React.FC = () => {
  return (
    <div
      className={WATERMARK_CLASS}
      style={WATERMARK_STYLE}
      aria-hidden="true"
    />
  );
};

export default EmulationWatermark;
